<template>
  <img :src="resolvedLogo" class="w-auto size-16" alt="Logo" loading="lazy" />

  <!-- Optional slot for title/text if needed in the future -->
  <!-- <span v-if="judul">{{ judul }}</span> -->

</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
  judul: {
    type: String,
  },
  logo: {
    type: String,
    default: "",
  },
});

// Build a safe absolute logo URL that works across nested routes
const resolvedLogo = computed(() => {
  const raw = (props.logo || "").trim();
  if (!raw) return "/storage/images/logosmall.png"; // sensible fallback

  // Already absolute http(s)
  if (/^https?:\/\//i.test(raw)) return raw;
  // Already absolute path
  if (raw.startsWith("/")) return raw;

  // Normalize commonly stored variants like "storage/..." or "public/..."
  const cleaned = raw
    .replace(/^public\//, "")
    .replace(/^storage\//, "");

  return `/storage/${cleaned}`;
});
</script>
